import React from "react";
import { ThemeProvider } from "styled-components";
import { Box, Flex } from "rebass";

import { H2, H3, H4, PageSection } from "components";

import theme from "../../theme";
import invertTheme from "../../invertTheme";

export const Stats = (props) => {
  return (
    <PageSection>
      <Flex width={1 / 1} flexWrap="wrap" ml={-4} mt={-4} py={[4, 5, 6]}>
        {props.items &&
          props.items.map((card, index) => (
            <Flex
              width={
                index % 5 === 0 || index % 5 === 1
                  ? [1 / 1, 1 / 2, 1 / 2]
                  : [1 / 1, 1 / 3, 1 / 3]
              }
              pl={4}
              pt={4}
              key={`card-${index}`}
              height="100%"
            >
              <ThemeProvider
                theme={
                  index % 5 === 0 || index % 5 === 2 || index % 5 === 4
                    ? invertTheme
                    : theme
                }
              >
                <Flex
                  flexDirection="column"
                  justifyContent="space-between"
                  height="100%"
                  style={{ position: "relative" }}
                  p={4}
                  bg={
                    index % 5 === 0 || index % 5 === 4
                      ? "violet"
                      : index % 5 === 2
                      ? "ash"
                      : "grey.1"
                  }
                >
                  <Box>
                    <H4 children="Stat" />
                    {card.stat && card.stat[0] && (
                      <H2
                        children={card.stat[0].text}
                        pt={[2, 3]}
                        pb={
                          index % 5 === 0 || index % 5 === 1
                            ? [2, 3, 4]
                            : [4, 5, 6]
                        }
                        fontSize={[6, 7]}
                      />
                    )}
                  </Box>
                  {card.stat_description && (
                    <H3 children={card.stat_description} fontSize={[2, 3]} />
                  )}
                </Flex>
              </ThemeProvider>
            </Flex>
          ))}
      </Flex>
    </PageSection>
  );
};



// WEBPACK FOOTER //
// ./src/slices/Stats/Stats.js